import React, { useState } from 'react';
import './Header.css';
import logo from '../../assets/PSJ(logo).png';
import { Link, } from 'react-router-dom';
import { FaTh, FaTimes, FaPhoneAlt, FaEnvelope, FaClock } from 'react-icons/fa';
// import gallery1 from '../../assets/gallery1.jpg'
// import gallery2 from '../../assets/gallery2.jpg'
// import gallery3 from '../../assets/gallery3.jpg'
// import gallery4 from '../../assets/gallery4.jpg'

import axios from 'axios';

// api integration.
const handleTransactionClick = async () => {
  try {
    const response = await axios.post('https://nseinvestuat.nseindia.com/nsemfdesk/login.htm', {
      clientCode: 'H30350',
      schemeCode: 'AXBDGP-GR',
      pan: 'ABCDE1234F',
      amount: 5000,
      txnType: 'BUY', // or 'SELL'
    });

    console.log('Transaction Response:', response.data);
    alert('Transaction submitted successfully!');
  } catch (err) {
    console.error('Transaction API Error:', err.message);
    alert('Transaction failed!');
  }
};




const Header = () => {





  const [menuOpen, setMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [activeLink, setActiveLink] = useState('/');
  // const location = useLocation();

  const handleClose = () => {
    setMenuOpen(false);
    setIsDropdownOpen(false);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(prev => !prev);
    setActiveLink('services');
  };

  const handleLinkClick = (path) => {
    setActiveLink(path);
    handleClose();
  };



  return (
    <>
      <div className="top-header">
        <div className="top-left">  B-06, Plot A1, Sector 59 Noida </div>
        <div className="top-center">Opening Hours: 9:00 AM - 07:00 PM</div>
        <div className="top-right">
          <Link to="mailto:info@example.com" target='_blank'> priyanshu@psjcapitalventures.com </Link>
          <Link to='https://www.instagram.com/psjcapitalofficial?stkn=cWR5c2RjdTJiYncw' target='_blank'><i className="fab fa-instagram"></i></Link>
          <Link to='https://www.linkedin.com/company/psj-capital-ventures/' target='_blank'><i class="fa-brands fa-linkedin"></i></Link>
          <Link to='https://www.youtube.com/@PSJCAPITALVENTURES' target='_blank'><i className="fa-brands fa-youtube"></i></Link>
          <Link to='https://x.com/PSJCAPITAL?t=rGFu7sIyfYbwws4C4xCDLQ&s=09' target='_blank'><i class="fa-brands fa-x-twitter"></i></Link>
          <Link to='https://www.facebook.com/profile.php?id=61575921059220&rdid=wd75JgB9Z2koC7S2&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1YfhDe2xk5%2F#' target='_blank'><i class="fa-brands fa-square-facebook"></i></Link>
          <Link to='https://wa.me/918108430942' target="_blank" ><i class="fa-brands fa-square-whatsapp"></i></Link>
        </div>
      </div>

      <nav className="navbar">
        <div className="nav-left">
          <img src={logo} alt="Logo" />
        </div>

        <div className={`nav-links ${menuOpen ? 'active' : ''}`}>
          <ul className="navbar-links">
            <li>
              <Link to="/" className={activeLink === '/' ? 'active' : ''} onClick={() => handleLinkClick('/')}>Home</Link>
            </li>
            <li>
              <Link to="/about" className={activeLink === '/about' ? 'active' : ''} onClick={() => handleLinkClick('/about')}>About Us</Link>
            </li>
            <li className="dropdown">
              <span onClick={toggleDropdown} className={`dropdown-toggle ${activeLink === 'services' ? 'active' : ''}`}>
                Our Services
              </span>
              <div className={`dropdown-content ${isDropdownOpen ? 'show' : ''}`}>
                <Link to="/mutual-funds" onClick={() => handleClose()}>Mutual Funds</Link>
                <Link to="/portfolio-management-services" onClick={() => handleClose()}>Portfolio Management Services</Link>
                <Link to="/alternative-investment-funds" onClick={() => handleClose()}>Alternative Investment Funds</Link>
                <Link to="/macro-treasury-research " onClick={() => handleClose()}>Macro/Treasury Research</Link>
                <Link to="/nri-corner" onClick={() => handleClose()}>NRI Corner</Link>
                <Link to="/family-offices" onClick={() => handleClose()}>Family Offices</Link>
                <Link to="/insurance" onClick={() => handleClose()}>Insurance</Link>
                <Link to="/loan-syndication" onClick={() => handleClose()}>Loan Syndication</Link>
                <Link to="/sme-ipo-advisory" onClick={() => handleClose()}>SME IPO Advisory</Link>
                <Link to="/fundraising-assistance" onClick={() => handleClose()}>Fundraising Assistance</Link>
                <Link to="/stock-broking" onClick={() => handleClose()}>Stock Broking</Link>
              </div>

            </li>
            <li>
              <Link to='https://www.youtube.com/@PSJCAPITALVENTURES' target='_blank'>Fund-o-pedia</Link>
            </li>
            <li>
              <Link to="/calculators" className={activeLink === '/calculators' ? 'active' : ''} onClick={() => handleLinkClick('/calculators')}>Calculator</Link>
            </li>
            <li>
              <Link to="/blog" className={activeLink === '/blog' ? 'active' : ''} onClick={() => handleLinkClick('/blog')}>Blogs</Link>
            </li>
            <li>
              <Link to="/contact" className={activeLink === '/contact' ? 'active' : ''} onClick={() => handleLinkClick('/contact')}>Contact Us</Link>
            </li>
            <div className='button-right'>


              <Link to="/nse-registration"><button className='redirect btn btn-dark'
              // onClick={() => window.open("https://www.nseinvest.com/nsemfdesk/login.htm", "_blank")}
              >
                Transaction login
              </button></Link>


              &nbsp;&nbsp;&nbsp;
              {/* <Link to="" target="_blank">
                <button className='redirect btn btn-dark' onClick={() => window.open("https://cal.com/", "_blank")}>Book Appointment</button>
              </Link> */}
              &nbsp;&nbsp;&nbsp;
              <button className="redirect btn btn-dark" onClick={() => window.open("https://cloud.mprofit.in/", "_blank")}>Client Login</button>
            </div>
          </ul>
        </div>

        <div className="nav-right">
          <div className="dots-icon" onClick={() => setIsSidebarOpen(true)}>
            <FaTh />
          </div>
          <button className={`hamburger ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(!menuOpen)}>
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>

      {menuOpen && <div className="overlay" onClick={handleClose} />}

      {isSidebarOpen && (
        <div className="sidebar">
          <button className="close-sidebar" onClick={() => setIsSidebarOpen(false)}>
            <FaTimes />
          </button>
          <div className="sidebar-content">
            <img src={logo} alt="Logo" className="sidebar-logo" />
            <p>
              At PSJ Capital Ventures, we craft personalized wealth strategies for HNIs, Business Families, Celebrities, Professionals, NRIs and Family offices seeking strategic financial guidance.


            </p>
            {/* <div className="sidebar-gallery">

              <img src={gallery1} alt={`Gallery 1`} />
              <img src={gallery2} alt={`Gallery 1`} />
              <img src={gallery3} alt={`Gallery 1`} />
              <img src={gallery4} alt={`Gallery 1`} />
              <img src={gallery2} alt={`Gallery 1`} />
              <img src={gallery1} alt={`Gallery 1`} />

            </div> */}
            <div className="sidebar-info">
              <p><strong></strong>  748, 7th Floor, Tower B, I-thum Tower, Sector 62 Noida </p>
              <p><FaPhoneAlt /> +91 8108 430 942</p>
              <p><FaEnvelope /> info@psjcapitalventures.com</p>
              <p><FaClock /> 9:00 Am - 07:00 Pm</p>
              <div className="social-icons1">
                <Link to='https://www.instagram.com/psjcapitalventuresofficial/?utm_source=ig_web_button_share_sheet' target='_blank'><i className="fab fa-instagram"></i></Link>
                <Link to='https://www.linkedin.com/company/psj-capital-ventures/' target='_blank'><i class="fa-brands fa-linkedin"></i></Link>
                <Link to='https://www.youtube.com/@PSJCAPITALVENTURES' target='_blank'><i className="fa-brands fa-youtube"></i></Link>
                <Link to='https://x.com/PSJCAPITAL?t=rGFu7sIyfYbwws4C4xCDLQ&s=09' target='_blank'><i class="fa-brands fa-x-twitter"></i></Link>
                <Link to='https://www.facebook.com/profile.php?id=61575921059220&rdid=wd75JgB9Z2koC7S2&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1YfhDe2xk5%2F#' target='_blank'><i class="fa-brands fa-square-facebook"></i></Link>
                <Link to='https://wa.me/918108430942' target="_blank" ><i class="fa-brands fa-square-whatsapp"></i></Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
